import { WidgetConfigWithLegends } from 'widgets/WidgetLegend/WidgetConfigWithLegends';
import { WidgetConfigWithHideableToolbar } from 'widgets/WidgetToolbarShowHidePanel/WidgetConfigWithHideableToolbar';

export interface IntraDayProfileWidgetLegends {
    hideExpectedVolume: boolean;
    hideActualTradedVolume: boolean;
    hideCumulativeExpectedVolume: boolean;
    hideCumulativeActualVolume: boolean;
    hideSpread: boolean;
    hideVolatility: boolean;
    hideAuctionVolume: boolean;
}

export interface IntraDayProfileConfiguration
    extends WidgetConfigWithLegends<IntraDayProfileWidgetLegends>,
        WidgetConfigWithHideableToolbar {
    bucketSize: number;
}

export const bucketDropDownValues = [2, 3, 5, 10, 15, 30];
export const initialIntraDayProfileConfiguration: IntraDayProfileConfiguration =
    {
        bucketSize: bucketDropDownValues[3],
        hideToolbar: false,
        hideExpectedVolume: false,
        hideActualTradedVolume: false,
        hideCumulativeActualVolume: false,
        hideCumulativeExpectedVolume: false,
        hideSpread: false,
        hideVolatility: false,
        hideAuctionVolume: false,
        hideExpectedVolumeLegend: false,
        hideActualTradedVolumeLegend: false,
        hideCumulativeActualVolumeLegend: false,
        hideCumulativeExpectedVolumeLegend: false,
        hideSpreadLegend: false,
        hideVolatilityLegend: false,
        hideAuctionVolumeLegend: false,
    };
